export default __webpack_public_path__ + "static/media/centrol_andes_3.805205c0.JPG";